import useMe from '@web/hooks/useMe'
import { DEFAULT_PROFILE_IMAGE, DEFAULT_USER_NICKNAME } from '@web/libs/constants'
import routes from '@web/libs/constants/routes'
import useOpenNaverAppClipModal from '@web/pages/[objectId]/review/components/UserClips/modal/useOpenNaverAppClipModal'
import useUpdateNaverAppModal from '@web/pages/checkin/components/modals/useUpdateNaverAppModal'

import { useGlobalStaticStateContext } from './useGlobalStaticState'
import { useGoTo } from './useGoTo'

const useGoToClip = () => {
  const { login, me } = useMe()
  const { goTo, goToLogin, goToClipNew, openClipViewer } = useGoTo()
  const { isFromNaverApp, hasNaverClipEditor, hasNaverClipViewer, isFromMapsApp } = useGlobalStaticStateContext()
  const { openModal: openUpdateNaverAppModal } = useUpdateNaverAppModal()
  const { openModal: openOpenNaverAppModal } = useOpenNaverAppClipModal()

  const goToClipCheckIn = () => {
    if (!login) {
      goToLogin()
      return null
    }

    if (isFromNaverApp) {
      if (hasNaverClipEditor) {
        const serviceDataJson = {
          channelName: me?.profile?.nickname ?? DEFAULT_USER_NICKNAME,
          channelId: me?.id,
          channelEmblem: me?.profile?.imageUrl ?? DEFAULT_PROFILE_IMAGE,
        }

        return goToClipNew(JSON.stringify(serviceDataJson))
      }

      return openUpdateNaverAppModal()
    }

    return openOpenNaverAppModal()
  }

  const goToClipViewer = (videoId: string, recId: string) => {
    if (isFromNaverApp) {
      if (hasNaverClipViewer) {
        return openClipViewer(videoId, recId)
      }
      return openUpdateNaverAppModal()
    }

    return goTo(routes.CLIP, { params: { videoId }, extraQuery: { recId } })
  }

  return {
    goToClipCheckIn,
    goToClipViewer,
  }
}

export default useGoToClip
